import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import {TableCell} from '@adsk/bim360-matrix-react-matrix-table';
import {getDataTypeName, getIconByDataType} from '../../../utils/issueAttributes-helpers';

const IssueAttributesAdminTypeIconAndName = ({container, dataType, svgIconDataTestId, titleDataTestId, disabled}) => {
  const className = cx('IssueAttributesAdminTypeIconAndName', {
    'IssueAttributesAdminTypeIconAndName--disabled': disabled
  });

  const title = getDataTypeName(dataType);
  const column = {
    tooltip: title,
    tooltipProps: {show: false}
  };

  return (
    <TableCell className={className} container={container} column={column}>
      <SvgIcon className="IssueAttributesAdminTypeIconAndName__icon" data-testid={svgIconDataTestId}>
        {getIconByDataType(dataType)}
      </SvgIcon>
      <span data-testid={titleDataTestId}>{title}</span>
    </TableCell>
  );
};

IssueAttributesAdminTypeIconAndName.displayName = 'IssueAttributesAdminTypeIconAndName';

IssueAttributesAdminTypeIconAndName.propTypes = {
  dataType: PropTypes.string.isRequired,
  titleDataTestId: PropTypes.string,
  svgIconDataTestId: PropTypes.string,
  container: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

export default IssueAttributesAdminTypeIconAndName;
